import React from 'react';
import { WrapLocaleReceiver } from '../I18N';
import { HandleIcon,Icon } from 'tntd';
export default WrapLocaleReceiver((props) => {
  const { record,onViewOpen,setOtherVisible, children, href, unmountHandle, jumpFun, iframeJump, Com, I18N, ...rest } = props;
  if(onViewOpen && record?.canJump){
    return (
      <HandleIcon className="custom-class" num={2}>
        <HandleIcon.Item  title={I18N.referenceinfo.index.xiangqing} desc={I18N.referenceinfo.index.xiangqing}>
            <Icon type="profile" onClick={()=>{
              const url = window.location.host + record?.goLink;
              window.parent.open(url);
            }}></Icon>
        </HandleIcon.Item>
      </HandleIcon>
    )}
  if(onViewOpen){
    return (
      <HandleIcon className="custom-class" num={2}>
        <HandleIcon.Item  title={I18N.referenceinfo.index.xiangqing} desc={I18N.referenceinfo.index.xiangqing}>
            <Icon type="profile" onClick={()=>{
              setOtherVisible(record);
            }}></Icon>
        </HandleIcon.Item>
      </HandleIcon>
    )}
  if (window.__isMultiTab__) {
    return (
      <a
        onClick={(evt) => {
            evt.preventDefault();
            if (unmountHandle && typeof unmountHandle === 'function') {
                unmountHandle();
            }
            let pathName = href;
            if (href && href.includes('?')) {
                pathName = href?.split('?')[0];
            }
            if(jumpFun && typeof jumpFun==='function'){
                jumpFun(href);
                return
            }
            const isInIframe = window?.self !== window?.top;
            if(iframeJump && isInIframe){
                if (pathName === window.location.pathname) {
                    window.parent.location.href = href;
                } else {
                    window.parent.open(href);
                }
                return
            }
            // if (pathName === window.location.pathname) {
                window.location.href = href;
            // } else {
            //     window.push(href);
            // }
        }}
      >
        {children}
      </a>
    );
  }
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
});
